var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTurnOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 86,
  viewBox: "0 0 80 86",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.08
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.2852 0.978027H45.7136V46.692H34.2852V0.978027Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.6676 8.04199C11.1498 13.5463 0 28.3569 0 45.7353C0 67.7888 17.9435 85.7351 39.9997 85.7351C62.056 85.7351 79.9995 67.7888 79.9995 45.7353C79.9995 28.3582 68.8514 13.5485 53.3353 8.04322V20.5089C62.3818 25.3074 68.5709 34.802 68.5709 45.7353C68.5709 61.4886 55.7529 74.3065 39.9997 74.3065C24.2466 74.3065 11.4286 61.4886 11.4286 45.7353C11.4286 34.8004 17.6193 25.3048 26.6676 20.5071V8.04199Z",
  fill: "black"
}))));
export { SvgTurnOff as ReactComponent };
export default __webpack_public_path__ + "5b0a11809bc56f6fbad7007287085099.svg";